/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from "react";
import { motion } from "framer-motion";
import { FiExternalLink } from "react-icons/fi";
import { useUI } from "../theme/ThemeProvider";
import WhatsLayout from "../layouts/WhatsLayout";
import Sales from "../pages/AdminDashboard/SalesPage";
// import Orders from "../pages/AdminDashboard/OrdersStagesPage";
import CustomersSummary from "../pages/AdminDashboard/CustomersSummaryPage";
import RecentOrders from "../pages/AdminDashboard/RecentOrdersPage";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export default function Dashboard() {
  const { theme, lang } = useUI();
  const isDark = theme === "dark";
  const isArabic = lang === "ar";
  const navigate = useNavigate();

  const { colors } = useUI();


  const [storeUrl, setStoreUrl] = React.useState("");

  useEffect(() => {
    try {
      const tenant = JSON.parse(localStorage.getItem("tenant") || "{}");
      const slug = tenant.storeSlug || tenant.StoreSlug || localStorage.getItem("companyStoreSlug");
      if (slug) {
        setStoreUrl(`https://${slug}.madar.iq/`);
      }
    } catch (e) {
      console.error("Error parsing tenant data", e);
    }
  }, []);

  return (
    <WhatsLayout title={null}>
      <div
        dir={isArabic ? "rtl" : "ltr"}
        className={`w-full min-h-screen transition-colors duration-300 ${isDark ? "bg-[#060b15]" : "bg-gray-50"}`}
        style={{ paddingBottom: "2rem" }}
      >
        <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8 py-4 sm:py-6 space-y-8 sm:space-y-10">

          {/* Custom Header with Store Link */}
          <div className="flex flex-wrap items-center justify-between gap-4 mb-2">
            <h2 className={`text-xl sm:text-2xl font-extrabold tracking-tight ${isDark ? "text-[#F2B441]" : "text-[#21003D]"}`}>
              {isArabic ? "لوحة التحكم" : "Dashboard"}
            </h2>

            {storeUrl && (
              <a
                href={storeUrl}
                target="_blank"
                rel="noreferrer"
                className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-bold transition-all shadow-lg ${isDark
                  ? "bg-slate-800 text-purple-400 border border-slate-700"
                  : "bg-white text-purple-600 border border-purple-100"
                  }`}
              >
                <span>{storeUrl.replace("https://", "").replace("/", "")}</span>
                <FiExternalLink />
              </a>
            )}
          </div>

          {/* قسم المبيعات */}
          <motion.section
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            className="w-full"
          >
            <Sales />
          </motion.section>

          {/* قسم الطلبات */}
          {/* <motion.section
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.1 }}
            className="w-full"
          >
            <Orders />
          </motion.section> */}

          {/* قسم الزبائن */}
          <motion.section
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.2 }}
            className="w-full"
          >
            <CustomersSummary />
          </motion.section>

          {/* قسم الطلبات الأخيرة */}
          <motion.section
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.3 }}
            className="w-full"
          >
            <RecentOrders />
          </motion.section>
        </div>
      </div>
    </WhatsLayout>
  );
}